import {Component, input, output} from '@angular/core';

@Component({
  selector: 'app-primary-button',
  imports: [],
  templateUrl: './primary-button.component.html',
  styleUrl: './primary-button.component.scss'
})
export class PrimaryButtonComponent {
  text = input.required<string>();

  isLoading = input<boolean>(false);
  isDisabled = input<boolean>(false);

  onClickEvent = output()
  onClick() {
    this.onClickEvent.emit();
  }
}
